export const P24_CHANNEL_TAG = "P24Channel";
export const P24_CHANNEL_ID = {
    BLIK: 154,
    CARDS: 241,
    PAYPO: 227, // Imported here because it's used in the domain (has special logic - address required)
    GOOGLE_PAY: 264,
    APPLE_PAY_PL: 252,
    APPLE_PAY: 253,
    BLIK_PLACE_POZNIEJ: 298,
};
export function isAppleChannelId(id) {
    switch (id.tag) {
        case "P24Channel": {
            return (id.contents === P24_CHANNEL_ID.APPLE_PAY_PL ||
                id.contents === P24_CHANNEL_ID.APPLE_PAY);
        }
        case "StripeChannel":
            return false;
    }
}
